module.exports = __webpack_public_path__ + "static/img/20240426_4.5c6dba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240426_4.png
// module id = 8UKG
// module chunks = 0